import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const FinancialStatementRestatementAuditSupport = () => {
  const serviceData = {
    title: "Financial Statement Restatement & Audit Support",
    heading: "Financial Statement Restatement & Audit Support",
    image: subTopicImages["Financial Statement Restatement & Audit Support"],
    intro:
      "Converting historical financials into investor-grade, compliant reporting",
    description: [
      "IPO requirements involve restating historical financial statements in accordance with applicable regulations (including Ind-AS), ensuring transparency, comparability and audit assurance. This process requires detailed review, reconciliations, adjustments and documentation support.",
      "Many companies experience challenges such as multiple accounting systems, incomplete documentation, legacy entries or non-standard reporting formats. We work closely with management and statutory auditors to help clean, restate and streamline financial reporting.",
    ],
    services: [
      {
        title: "Our Support Covers",
        list: [
          "review of historical financial statements",
          "assistance in preparing restated financials",
          "support in Ind-AS alignment & disclosures",
          "preparation of detailed schedules & workings",
          "consolidation & group reporting assistance",
          "coordination with auditors for queries & clarifications",
          "establishing consistency in accounting treatment",
        ],
        extraInfo:
          "We ensure accuracy, defensibility and traceability across all data.",
      },
    ],
    benefitsIntro: "Objective",
    benefits: [
      "to ensure your financials reflect the true financial position",
      "to meet regulatory reporting and investor expectations",
      "to enable smooth statutory audit completion",
    ],
    research:
      "Our involvement reduces delays, clarifies issues early and improves audit preparedness.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default FinancialStatementRestatementAuditSupport;
